import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AriaChat from "@/components/AriaChat";
import CookieConsent from "@/components/CookieConsent";
import MusicPlayer from "@/components/MusicPlayer";
import WhatsAppButton from "@/components/WhatsAppButton";
import BehaviorTracker from "@/components/BehaviorTracker";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import PortfolioPage from "@/pages/PortfolioPage";
import BookingPage from "@/pages/BookingPage";
import PaymentPage from "@/pages/PaymentPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ContactPage from "@/pages/ContactPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ClientPortal from "@/pages/ClientPortal";
import ClientDashboard from "@/pages/ClientDashboard";
import ClientGallery from "@/pages/ClientGallery";
import PromotionsPage from "@/pages/PromotionsPage";
import PartnerPortal from "@/pages/PartnerPortal";
import PartnerDashboard from "@/pages/PartnerDashboard";
import AffiliatesPage from "@/pages/AffiliatesPage";
import RecommendationsPage from "@/pages/RecommendationsPage";
import ItemDetailPage from "@/pages/ItemDetailPage";
import CommunityPage from "@/pages/CommunityPage";
import ForumDetailPage from "@/pages/ForumDetailPage";
import SuggestionsPage from "@/pages/SuggestionsPage";
import ShopPage from "@/pages/ShopPage";
import EventsPage from "@/pages/EventsPage";
import TicketsPage from "@/pages/TicketsPage";
import EventDetailPage from "@/pages/EventDetailPage";
import EventCheckinPage from "@/pages/EventCheckinPage";
import TicketPage from "@/pages/TicketPage";
import EventAnalyticsPage from "@/pages/EventAnalyticsPage";
import CalendarPage from "@/pages/CalendarPage";
import EventLandingPage from "@/pages/EventLandingPage";
import ReferralPage from "@/pages/ReferralPage";
import SubscribePage from "@/pages/SubscribePage";
import PosterGeneratorPage from "@/pages/PosterGeneratorPage";
import PhotoBoothPage from "@/pages/PhotoBoothPage";
import DownloadPage from "@/pages/DownloadPage";
import BudgetCalculatorPage from "@/pages/BudgetCalculatorPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AdminGalleryManager from "@/pages/AdminGalleryManager";
import EditorPortal from "@/pages/EditorPortal";
import AdminActivityLog from "@/pages/AdminActivityLog";
import AdminApprovalsPage from "@/pages/AdminApprovalsPage";
import MarketplacePage from "@/pages/MarketplacePage";
import UGCUploadPage from "@/pages/UGCUploadPage";
import CartBlancJAPage from "@/pages/CartBlancJAPage";
import ProfilePage from "@/pages/ProfilePage";
import ChauffeurApp from "@/pages/ChauffeurApp";
import DriverDashboard from "@/pages/DriverDashboard";
import DriverSignupPage from "@/pages/DriverSignupPage";
import TripSharePage from "@/pages/TripSharePage";
import LiguaneaArtFestivalPage from "@/pages/LiguaneaArtFestivalPage";
import PaymentsPage from "@/pages/PaymentsPage";
import SupportPage from "@/pages/SupportPage";
import MediaStudioPage from "@/pages/MediaStudio";
import SuggestionBoxButton from "@/components/SuggestionBoxButton";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import ErrorBoundary from "@/components/ErrorBoundary";
import { UploadQueueProvider } from "@/contexts/UploadQueueContext";
import UploadQueueTray from "@/components/UploadQueueTray";

function App() {
  return (
    <LanguageProvider>
    <ErrorBoundary>
    <div className="grain-overlay min-h-screen bg-luxury-black">
      <BrowserRouter>
        <UploadQueueProvider>
        <Header />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/vip" element={<ClientPortal />} />
            <Route path="/vip/dashboard" element={<ClientDashboard />} />
            <Route path="/vip/gallery/:galleryId" element={<ClientGallery />} />
            <Route path="/promotions" element={<PromotionsPage />} />
            <Route path="/partner" element={<PartnerPortal />} />
            <Route path="/partner/dashboard" element={<PartnerDashboard />} />
            <Route path="/affiliates" element={<AffiliatesPage />} />
            <Route path="/recommendations" element={<RecommendationsPage />} />
            <Route path="/recommendations/:category/:itemId" element={<ItemDetailPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/community/:forumId" element={<ForumDetailPage />} />
            <Route path="/suggestions" element={<SuggestionsPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/tickets" element={<TicketsPage />} />
            <Route path="/events/:eventId" element={<EventDetailPage />} />
            <Route path="/events/:eventId/checkin" element={<EventCheckinPage />} />
            <Route path="/events/ticket/:ticketId" element={<TicketPage />} />
            <Route path="/admin/events/:eventId/analytics" element={<EventAnalyticsPage />} />
            <Route path="/admin/gallery/:galleryId" element={<AdminGalleryManager />} />
            <Route path="/editor" element={<EditorPortal />} />
            <Route path="/admin/activity" element={<AdminActivityLog />} />
            <Route path="/admin/approvals" element={<AdminApprovalsPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/marketplace/success" element={<MarketplacePage />} />
            <Route path="/ugc/:eventId" element={<UGCUploadPage />} />
            <Route path="/cartblancja" element={<CartBlancJAPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/e/:eventSlug" element={<EventLandingPage />} />
            <Route path="/referral" element={<ReferralPage />} />
            <Route path="/subscribe" element={<SubscribePage />} />
            <Route path="/subscribe/success" element={<SubscribePage />} />
            <Route path="/create-poster" element={<PosterGeneratorPage />} />
            <Route path="/photo-booth" element={<PhotoBoothPage />} />
            <Route path="/download" element={<DownloadPage />} />
            <Route path="/budget-calculator" element={<BudgetCalculatorPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/chauffeur" element={<ChauffeurApp />} />
            <Route path="/driver" element={<DriverDashboard />} />
            <Route path="/driver/signup" element={<DriverSignupPage />} />
            <Route path="/trip/:shareToken" element={<TripSharePage />} />
            <Route path="/liguanea" element={<LiguaneaArtFestivalPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/studio" element={<MediaStudioPage />} />
          </Routes>
        </main>
        <Footer />
        <AriaChat />
        <MusicPlayer />
        <WhatsAppButton />
        <SuggestionBoxButton />
        <BehaviorTracker />
        <CookieConsent />
        <UploadQueueTray />
        <Toaster position="top-right" theme="dark" />
        </UploadQueueProvider>
      </BrowserRouter>
    </div>
    </ErrorBoundary>
    </LanguageProvider>
  );
}

export default App;
